// const imagesLoaded = require('imagesloaded');
import GSAP from 'gsap'

// Map number x from range [a, b] to [c, d]
const map = (x, a, b, c, d) => ((x - a) * (d - c)) / (b - a) + c

// Linear interpolation
// const lerp = (a, b, n) => (1 - n) * a + n * b;
const lerp = (p1, p2, t) => GSAP.utils.interpolate(p1, p2, t)

// const clamp = (num, min, max) => num <= min ? min : num >= max ? max : num;
const clamp = (min, max, number) => GSAP.utils.clamp(min, max, number)

const randomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

// Gets the mouse position
const getMousePos = (e) => ({ x: e.clientX, y: e.clientY })

// Preload images
const preloadImages = (selector = 'img') =>
  new Promise((resolve) =>
    imagesLoaded(document.querySelectorAll(selector), { background: true }, resolve)
  )

// Preload images
const preloadFonts = (id) =>
  new Promise((resolve) => {
    WebFont.load({
      typekit: {
        id: id,
      },
      active: resolve,
    })
  })

const deviceType = () => {
  //use userAgentData
  // console.log(navigator.userAgentData)
  // if (navigator.userAgentData) {
  //   const { mobile, tablet } = navigator.userAgentData;
  //   if (mobile) return "mobile";
  //   if (tablet) return "tablet";
  //   return "desktop";
  // }
  //use navigator.userAgent
  const ua = navigator.userAgent
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet'
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return 'mobile'
  }
  return 'desktop'
}

const isTouchDevice = () =>
  'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0

const delay = (n) => {
  n = n || 2000
  return new Promise((done) => {
    setTimeout(() => {
      done()
    }, n)
  })
}

const isEmpty = (obj) => Object.keys(obj).length === 0

const formatSizeUnits = (bytes) => {
  if (bytes >= 1073741824) {
    bytes = (bytes / 1073741824).toFixed(2) + ' GB'
  } else if (bytes >= 1048576) {
    bytes = (bytes / 1048576).toFixed(2) + ' MB'
  } else if (bytes >= 1024) {
    bytes = (bytes / 1024).toFixed(2) + ' KB'
  } else if (bytes > 1) {
    bytes = bytes + ' bytes'
  } else if (bytes == 1) {
    bytes = bytes + ' byte'
  } else {
    bytes = '0 bytes'
  }
  return bytes
}

// Function to get a cookie value by name
const getCookieValue = (cookieName) => {
  const name = cookieName + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const cookieArray = decodedCookie.split(';')

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i]
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length)
    }
  }
  return ''
}

export {
  map,
  lerp,
  clamp,
  randomNumber,
  getMousePos,
  preloadImages,
  preloadFonts,
  deviceType,
  delay,
  isTouchDevice,
  isEmpty,
  formatSizeUnits,
  getCookieValue,
}
